/* global G */
import { curry, isObj } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import sequenceComponentState from 'lib/sequence/component/state'
import { get, set } from 'lib/sequence/component/state/value'
import { hide } from 'lib/sequence/component/state/hidden'
import validate from 'lib/sequence/model/validate'

const {
  set: setConfiguration,
} = sequenceComponentState('configuration')

/**
 * If `value` is a stringified JSON object with a property with the same name as the current
 * session's language, returns its value; otherwise, returns the value of its first property.
 *
 * If `value` is not an object, returns it as is.
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {string} value
 */
const translatedValue = (module, value) => {
  try {
    const object = JSON.parse(value)

    if (isObj(object)) {
      const language = module[G.ADAPTER][G.SESSION][G.STATE][G.LANGUAGE]
      return object[language] || object[Object.keys(object)[0]]
    }
  } catch (ignored) {} // returning raw value

  return value
}

/**
 * Updates the detail section according to the values from the form section.
 *
 * Only to be used in the module's detail action.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
// eslint-disable-next-line no-unused-vars
const updateDetail = async (module, component, event) => {
  const model = module[G.MODEL]
  const rootComponent = module[G.STATE][G.ACTION][G.COMPONENT]

  const { form, detail } = find(rootComponent)
  const { label: formLabel, dynamicDataConfiguration: formData } = find(form)
  const { label, error, dynamicData: dynamicForm } = find(detail)

  hide(error) // reset error state before validation

  await validate(model)(form)

  try {
    set(label, translatedValue(module, get(formLabel)) || null)

    const formDataValue = get(formData)
    const formDataObject = formDataValue ? JSON.parse(formDataValue) : null

    formDataObject && setConfiguration(dynamicForm, formDataObject)
  } catch (e) {
    setConfiguration(dynamicForm, [])
  }

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(updateDetail)
